export default __webpack_public_path__ + "static/media/products-banner.836a67ee.jpg";